module.exports = __webpack_public_path__ + "img/project-management.db8c7a5e.png";